<template>
  <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle" :tip="'防伪标识内容设置'">

    <el-tabs :value="activeTab" type="border-card" style="margin-bottom: 20px;">
      <el-tab-pane label="标题字体设置" name="first">
        <FontSetting v-model="titleFont" :configs="['fontFamily', 'fontSize', 'fontWeight', 'lineHeight']" />
      </el-tab-pane>
      <el-tab-pane label="内容字体设置" name="second">
        <FontSetting v-model="textFont" :configs="['fontFamily', 'fontSize', 'fontWeight', 'lineHeight']" />
      </el-tab-pane>
    </el-tabs>
    
    <ItemSetting label="显示正品">
      <el-switch v-model="showIndex" :active-value="0" :inactive-value="1"></el-switch>
    </ItemSetting>

    <div class="item-list">
      <ContentCard class="content-item" :title="'官方正品'" v-model="data[0]" :showRemove="false" />
      <ContentCard class="content-item" :title="'非官方正品'" v-model="data[1]" :showRemove="false" />
    </div>

  </EditBox>
</template>

<script>
import EditBox from "./box/EditBox"
import ContentCard from "./card/ContentCard"
import ItemSetting from "./setting/ItemSetting"
import FontSetting from "./setting/FontSetting"
import editMixin from './mixins/editMixin'

export default {
  name: 'VerifyEdit',
  mixins: [editMixin],
  components: {
    ContentCard,
    EditBox,
    ItemSetting,
    FontSetting
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activeTab: 'first'
    }
  },
  computed: {
    titleFont: {
      get() {
        return this.value.titleFont || {}
      },
      set(val) {
        this.updateValue({ titleFont: val })
      }
    },
    textFont: {
      get() {
        return this.value.textFont || {}
      },
      set(val) {
        this.updateValue({ textFont: val })
      }
    },
    showIndex: {
      get() {
        return this.value.showIndex || 0
      },
      set(val) {
        this.updateValue({ showIndex: val })
      }
    },
    data: {
      get() {
        return this.value.data || []
      },
      set(val) {
        this.updateValue({ data: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-list {
  .content-item {
    margin-bottom: 12px;
  }
}
</style>
